module.exports = __webpack_public_path__ + "static/img/frame.4d96a94.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/solution/frame.png
// module id = VZia
// module chunks = 1